import React from 'react';
import { Check } from 'lucide-react';
import { ServicePageLayout } from '../components/ServicePageLayout';
export function FullCarDetailPage() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Full Car Detail',
    provider: {
      '@type': 'LocalBusiness',
      name: "Mike's Pro Detail",
      telephone: '+18183819905'
    },
    areaServed: ['Camarillo', 'Thousand Oaks', 'Ventura County', 'Los Angeles'],
    description: 'Complete mobile full car detailing service combining deep interior cleaning and premium exterior wash, clay bar, and wax protection.'
  };
  return <ServicePageLayout title="Full Car Detail in Los Angeles & Ventura County" subtitle="Our most popular package. A complete bumper-to-bumper transformation combining our premium interior and exterior detailing services." metaDescription="Get a complete full car detail in Camarillo, Thousand Oaks, and Ventura County. Mobile service includes interior deep clean and exterior wax. Call (818) 381-9905." schema={schema} data-id="element-405">
      <p data-id="element-406">
        If you want your vehicle to look and feel as close to brand new as
        possible, our <strong data-id="element-407">Full Car Detail</strong> is the ultimate solution.
        This comprehensive package combines the deep-cleaning power of our
        interior detailing with the protective, gloss-enhancing benefits of our
        exterior detailing. At Mike's Pro Detail, we provide top-tier mobile
        auto detailing in Camarillo CA, Thousand Oaks, and throughout Ventura
        County, bringing a complete automotive makeover directly to your
        driveway or workplace.
      </p>

      <h2 data-id="element-408">What's Included in a Full Detail?</h2>
      <p data-id="element-409">
        The Full Detail package leaves no stone unturned. We spend hours
        meticulously cleaning, restoring, and protecting every surface of your
        vehicle.
      </p>

      <h3 data-id="element-410">Exterior Services:</h3>
      <ul className="space-y-4 my-6 list-none pl-0" data-id="element-411">
        <li className="flex items-start" data-id="element-412">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-413" />
          <span data-id="element-414">
            <strong data-id="element-415">Scratch-Free Hand Wash:</strong> Two-bucket wash method to
            safely remove surface dirt and grime.
          </span>
        </li>
        <li className="flex items-start" data-id="element-416">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-417" />
          <span data-id="element-418">
            <strong data-id="element-419">Decontamination & Clay Bar:</strong> Removal of embedded
            iron particles, tree sap, and road tar to leave the paint smooth.
          </span>
        </li>
        <li className="flex items-start" data-id="element-420">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-421" />
          <span data-id="element-422">
            <strong data-id="element-423">Wheel & Tire Detail:</strong> Deep cleaning of wheel
            barrels, faces, and tires, finished with a premium no-sling
            dressing.
          </span>
        </li>
        <li className="flex items-start" data-id="element-424">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-425" />
          <span data-id="element-426">
            <strong data-id="element-427">Paint Protection:</strong> Application of a high-grade
            hybrid ceramic wax or sealant for months of gloss and UV protection.
          </span>
        </li>
      </ul>

      <h3 data-id="element-428">Interior Services:</h3>
      <ul className="space-y-4 my-6 list-none pl-0" data-id="element-429">
        <li className="flex items-start" data-id="element-430">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-431" />
          <span data-id="element-432">
            <strong data-id="element-433">Deep Vacuuming & Extraction:</strong> Thorough removal of
            dirt and pet hair, followed by hot water extraction for carpets and
            cloth seats.
          </span>
        </li>
        <li className="flex items-start" data-id="element-434">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-435" />
          <span data-id="element-436">
            <strong data-id="element-437">Leather Treatment:</strong> Gentle cleaning and premium
            conditioning to restore softness and prevent cracking.
          </span>
        </li>
        <li className="flex items-start" data-id="element-438">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-439" />
          <span data-id="element-440">
            <strong data-id="element-441">Surface Sanitization:</strong> Steam cleaning of vents, cup
            holders, and dashboard to kill bacteria and remove sticky residues.
          </span>
        </li>
        <li className="flex items-start" data-id="element-442">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-443" />
          <span data-id="element-444">
            <strong data-id="element-445">Crystal Clear Glass:</strong> Streak-free cleaning of all
            interior and exterior windows and mirrors.
          </span>
        </li>
      </ul>

      <h2 data-id="element-446">The Ultimate Value and Convenience</h2>
      <p data-id="element-447">
        Booking a Full Car Detail is the most cost-effective way to completely
        reset your vehicle's condition. Whether you are preparing to sell your
        car, returning a lease, or simply want to fall in love with your daily
        driver all over again, this package delivers unmatched results. Plus,
        because we are a fully mobile operation, you don't have to waste your
        day sitting in a waiting room. We bring our own water and power,
        allowing you to continue working or relaxing at home while we transform
        your car.
      </p>

      <h2 data-id="element-448">Your Local Mobile Detailing Experts</h2>
      <p data-id="element-449">
        When residents search for "Car Detailing Camarillo" or "Mobile Detailing
        Ventura County", they consistently choose Mike's Pro Detail for our
        reliability, attention to detail, and exceptional customer service. From
        Calabasas to Moorpark, we are dedicated to providing the highest
        standard of mobile auto detailing available in Southern California.
      </p>
    </ServicePageLayout>;
}